import React from 'react'

import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardActions from "@material-ui/core/CardActions";

import { withStyles,
TextField, MenuItem, Button } from "@material-ui/core";

import { withFormik } from "formik";
import * as Yup from "yup";


const styles= ()=>({
    card:{
        maxWidth: 420,
        // marginTop:50
    },
    container: {
        display: 'flex',
        justifyContet: 'center'
    },
    actions: {
        float: 'right'
    }
})

const statusCategory = [
    {
        value: "pending",
        label: "pending"
      },
      {
        value: "complete",
        label: "complete"
      }
]

const UpdateForm_=(props)=>{
    // const {classes}= props;
    const {
        classes,
        values,
        touched,
        errors,
        isSubmitting,
        handleChange,
        handleBlur,
        handleSubmit,
        handleReset,
        customer,
        submithandlerProp
      } = props;

    return(
        <div className={classes.container}>

            <form onSubmit={handleSubmit}>
                <Card className={classes.card}>            

                    <CardContent>
                  
                        <TextField
                        id='invoice'
                        label="Invoice"
                        margin="dense"
                        variant="outlined"
                        fullWidth
                        value={values.invoice}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        helperText={touched.invoice? errors.invoice  :""}
                        error={touched.invoice && Boolean(errors.invoice)}
                        />

                        <TextField
                        id='customerName'
                        label="Customer Name"
                        margin="dense"
                        variant="outlined"
                        fullWidth
                        value={values.customerName}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        helperText={touched.customerName? errors.customerName : ""}
                        error={touched.customerName && Boolean(errors.customerName)}
                        />


                        <TextField 
                        id="email"
                        label="Email"
                        margin="dense"
                        variant="outlined"
                        fullWidth
                        type="email"
                        value={values.email}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        helperText={touched.email? errors.email : ""}
                        error={touched.email && Boolean(errors.email)}
                        />

        

                        <TextField
                        id="profit"
                        label="Profit"
                        margin="dense"
                        variant="outlined"
                        fullWidth
                        value={values.profit}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        helperText={touched.profit? errors.profit : ""}
                        error={touched.profit && Boolean(errors.profit)}
                        />

<TextField
              select
              id="status"
              label="Status"
              value={values.status}
              onChange={handleChange("status")}
              helperText={touched.status ? errors.status : ""}
              error={touched.status && Boolean(errors.status)}
              margin="dense"
              variant="outlined"
              fullWidth
            >
              {statusCategory.map(option => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </TextField>

                    </CardContent>
                    <CardActions className={classes.actions}>
                        <Button color="primary" type="submit"
                        disabled={isSubmitting}
                        >Update</Button>
                    </CardActions>
                </Card>
            </form>
        </div>
    )
}




const UpdateForm= withFormik({
    mapPropsToValues: (props
    //     {
    //     invoice,
    //     customerName,
    //     email,
    //     profit,
    //     status,
    //     customer,
    //     submithandlerProp
    // }
    
    )=>{
        console.log(props)
        const {customer , ...rest}=props
        return {
            invoice: customer.invoice || "",
            customerName: customer.customer || "",
            email: customer.email || "",
            profit: customer.profit || "",
            status: customer.status || "",
        }
    },
    validationSchema: Yup.object().shape({
        invoice: Yup.string().required("Required"),
        customerName: Yup.string().required("Required"),
        email: Yup.string()
        .email("Enter a valid email")
        .required("Email is required"),
        status: Yup.string().required("select status"),
        profit: Yup.string()
        .required("Required"),
        
    }),
    // handleSubmit: (values, { setSubmitting }) =>{
    //     console.log(rest)
    //     //console.log(submithandlerProp())
    //     setTimeout(()=>{
    //         //submtting
    //         //this.submithandlerProp()
    //         // submithandlerProp()
    //         alert(JSON.stringify(values, null,2))
    //         setSubmitting(false)
    //     }, 1000)
    // }
    handleSubmit: (values, formikBag) =>{
        console.log(formikBag.props)
        const {props,setSubmitting} =formikBag
        setTimeout(()=>{
            //alert(JSON.stringify(values, null,2))
            setSubmitting(false)
            props.submithandlerProp(values)
        },500)
       
    }
}
)(UpdateForm_)


export default  withStyles(styles)(UpdateForm) 